import gql from 'graphql-tag';

export default gql`
  mutation login(
    $userName: String!
    $password: String!
    $rememberMe: Boolean!
    $agentName: String
    $application: LoginApplication = MYALLEGIANT
  ) {
    login(
      userName: $userName
      password: $password
      agentName: $agentName
      rememberMe: $rememberMe
      application: $application
    ) {
      viewer {
        userName
        firstName
        forceResetPassword
        id
      }
      token
    }
  }
`;
